__turbopack_context__.v({
  "miniTitle": "tPb70a_miniTitle",
  "smallWrapper": "tPb70a_smallWrapper",
});
